import React, { useState } from 'react';
import { 
  BookOpen, Sparkles, Camera, Award, Brain, AlertTriangle, 
  Search, Zap, Wrench, Microscope, Package, Lightbulb, 
  Users, Target, Layers, UserCheck, CheckCircle, Focus, 
  Trophy, Instagram, Plus, Minus, Palette, TrendingUp,
  Clock, Star, Heart, Crown, Gem, Coffee, ChevronDown, ChevronUp
} from 'lucide-react';
import styles from './Courses.module.css';
import Button from '../button/Button';

const AdditionalCourses = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedCourses, setExpandedCourses] = useState({});

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const toggleCourse = (courseNumber) => {
    setExpandedCourses(prev => ({
      ...prev,
      [courseNumber]: !prev[courseNumber]
    }));
  };

  const beginnerSessions = [
    {
      number: 1,
      title: "שיעור ראשון - היכרות + תיאורטי",
      topics: [
        { text: "אנטומיה ומבנה הציפורן", icon: <Brain className={styles.contentIcon} /> },
        { text: "פתולוגיות ומחלות ציפורניים נפוצות", icon: <Search className={styles.contentIcon} /> },
        { text: "הכרת כלי העבודה הנכונים", icon: <Wrench className={styles.contentIcon} /> },
        { text: "סטריליזציה, היגיינה וסביבת עבודה בטוחה", icon: <Sparkles className={styles.contentIcon} /> },
        { text: "שיוף צורות שונות", icon: <Target className={styles.contentIcon} /> },
        { text: "עבודה על יד אימון", icon: <Users className={styles.contentIcon} /> },
      ]
    },
    {
      number: 2,
      title: "שיעור שני - מעשי",
      topics: [
        { text: "חזרה על החומר התיאורטי מהשיעור הקודם", icon: <BookOpen className={styles.contentIcon} /> },
        { text: "הכנה של כלי העבודה וסביבת עבודה", icon: <Wrench className={styles.contentIcon} /> },
        { text: "הכרת כל ראשי השיוף והשימוש בהם", icon: <Layers className={styles.contentIcon} /> },
        { text: "מבוא למניקור יבש", icon: <Sparkles className={styles.contentIcon} /> },
        { text: "מוצרי לק ג'ל ושיטת עבודה מלאה", icon: <Package className={styles.contentIcon} /> },
        { text: "תרגול על יד אימון", icon: <Users className={styles.contentIcon} /> },
      ]
    },
    {
      number: 3,
      title: "שיעור שלישי - מעשי",
      topics: [
        { text: "הדגמה מלאה למניקור על מודליסטית", icon: <UserCheck className={styles.contentIcon} /> },
        { text: "שיטת מבנה אנטומי ייחודית", icon: <Target className={styles.contentIcon} /> },
        { text: "מריחה צמודה לקוטיקולה", icon: <Focus className={styles.contentIcon} /> },
        { text: "תרגול עצמי על מודליסטית", icon: <Users className={styles.contentIcon} /> },
      ]
    },
    {
      number: 4,
      title: "שיעור רביעי - מעשי",
      topics: [
        { text: "יישום הטכניקה לפי כל השלבים שנלמדו", icon: <CheckCircle className={styles.contentIcon} /> },
        { text: "הסרה נכונה והתאמת הצורה למבנה הציפורן", icon: <Target className={styles.contentIcon} /> },
        { text: "בנייה בטיפס הפוך בשיטה החדשנית", icon: <Layers className={styles.contentIcon} /> },
        { text: "תרגול מעשי על מודליסטית", icon: <Users className={styles.contentIcon} /> },
      ]
    },
    {
      number: 5,
      title: "שיעור חמישי - מעשי",
      topics: [
        { text: "תיקונים מקצועיים (משי, ג'ל בנייה, פוליג'ל)", icon: <CheckCircle className={styles.contentIcon} /> },
        { text: "השלמות ותיקון ציפורניים", icon: <Wrench className={styles.contentIcon} /> },
        { text: "טכניקות מתקדמות לגימור מושלם", icon: <Sparkles className={styles.contentIcon} /> },
        { text: "תרגול מעשי על מודליסטית", icon: <Users className={styles.contentIcon} /> },
      ]
    },
    {
      number: 6,
      title: "שיעור שישי - סיום",
      topics: [
        { text: "יישום מלא של כל השלבים מהתחלה ועד הסוף", icon: <Award className={styles.contentIcon} /> },
        { text: "צילום מקצועי לתיעוד העבודות", icon: <Camera className={styles.contentIcon} /> },
        { text: "טיפים להתנהלות נכונה ברשתות החברתיות", icon: <TrendingUp className={styles.contentIcon} /> },
        { text: "שיחת סיום וקבלת תעודה", icon: <Trophy className={styles.contentIcon} /> },
      ]
    }
  ];

  const courses = [
    {
      number: 1,
      icon: <Award className={styles.sessionIcon} />,
      title: "קורס לק ג'ל מתחילות - מסלול בסיס",
      duration: "6 מפגשים",
      sessions: beginnerSessions,
    },
    {
      number: 2,
      icon: <Star className={styles.sessionIcon} />,
      title: "השתלמות יומית למקצועיות",
      duration: "5 שעות",
      content: [
        { text: "תיקון טעויות תוך כדי עבודה", icon: <CheckCircle className={styles.contentIcon} /> },
        { text: "שיטה ברורה שתלווה אותך בכל לקוחה", icon: <Target className={styles.contentIcon} /> },
        { text: "קיצור זמנים משמעותי בטיפולים", icon: <Clock className={styles.contentIcon} /> },
        { text: "גימור נקי ומדויק ברמה גבוהה", icon: <Sparkles className={styles.contentIcon} /> },
        { text: "תוצאה שמחזיקה ומביאה לקוחות חוזרות", icon: <Heart className={styles.contentIcon} /> },
        { text: "ביטחון מקצועי אמיתי", icon: <Trophy className={styles.contentIcon} /> },
        { text: "ליווי אישי גם אחרי — עד שאת שולטת בזה", icon: <UserCheck className={styles.contentIcon} /> }
      ]
    }
  ];

  return (
    <div className={styles.additionalCoursesContainer}>
      <div className={styles.additionalHeader}>
        <h1 className={styles.additionalMainTitle}>הקורסים שלנו</h1>
        <h2 className={styles.additionalSubtitle}>ריכזתי עבורך את הדרכים שלך להתחיל את הדרך שלך בעולם היופי</h2>
        <div className={styles.additionalCourseInfo}>
          <span>2 מסלולי לימוד</span>
          <span>מתחילות עד מקצועיות</span>
          <span>ליווי אישי וצמוד</span>
        </div>
        
        <div className={styles.additionalExpandButtonContainer}>
          <button 
            className={styles.additionalExpandButton} 
            onClick={toggleExpanded}
            aria-label={isExpanded ? "הסתר קורסים" : "הצג קורסים"}
          >
            {isExpanded ? (
              <>
                <Minus className={styles.additionalExpandIcon} />
                <span>לחצי כדי להסתיר את תיאור הקורסים</span>
              </>
            ) : (
              <>
                <Plus className={styles.additionalExpandIcon} />
                <span>לחצי כדי לצפות בכל הקורסים</span>
              </>
            )}
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className={styles.additionalCoursesContainerInner}>
          {courses.map((course) => (
            <div key={course.number} className={styles.additionalCourseCard}>
              <div className={styles.additionalCourseHeader}>
                <div className={styles.additionalCourseNumber}>מסלול {course.number}</div>
                <div className={styles.additionalIconContainer}>
                  {course.icon}
                </div>
              </div>
              
              <h3 className={styles.additionalCourseTitle}>{course.title}</h3>
              
              <div className={styles.additionalCourseDetails}>
                <div className={styles.additionalDuration}>{course.duration}</div>
                <button 
                  className={styles.additionalCourseExpandButton}
                  onClick={() => toggleCourse(course.number)}
                  aria-label={expandedCourses[course.number] ? "פחות פרטים" : "עוד פרטים"}
                >
                  {expandedCourses[course.number] ? (
                    <>
                      <ChevronUp className={styles.additionalCourseExpandIcon} />
                      <span>פחות פרטים</span>
                    </>
                  ) : (
                    <>
                      <ChevronDown className={styles.additionalCourseExpandIcon} />
                      <span>עוד פרטים</span>
                    </>
                  )}
                </button>
              </div>
              
              {expandedCourses[course.number] && (
                <div className={styles.additionalContentContainer}>
                  {course.sessions ? (
                    course.sessions.map((session) => (
                      <div key={session.number} className={styles.sessionBlock}>
                        <h4 className={styles.sessionTitle}>{session.title}</h4>
                        {session.topics.map((item, index) => (
                          <div key={index} className={styles.additionalContentItem}>
                            <span className={styles.additionalContentIconWrapper}>
                              {item.icon}
                            </span>
                            <span className={styles.additionalContentText}>
                              {item.text}
                            </span>
                          </div>
                        ))}
                      </div>
                    ))
                  ) : (
                    course.content.map((item, index) => (
                      <div key={index} className={styles.additionalContentItem}>
                        <span className={styles.additionalContentIconWrapper}>
                          {item.icon}
                        </span>
                        <span className={styles.additionalContentText}>
                          {item.text}
                        </span>
                      </div>
                    ))
                  )}

                  <Button text="נתי, קחי אותי להרשמה"/>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdditionalCourses;